<template>
  <div id="root">
    <Nav
      :appAreas="appAreas"
      :mapPages="mapPages"
      :selectedAppArea.sync="selectedAppArea"
      :selectedMapPage.sync="selectedMapPage"
      :questionCode="selectedQuestionCode"
      :questionTitle="selectedQuestionTitle"
      :gistaThemes="gistaThemes"
      :selectedGistaAttribute.sync="selectedGistaAttribute"
      @update:questionCode="onQuestionPicked"
      @update:questionTitle="selectedQuestionTitle = $event"
    />
    <LeafletMap
      :mapPageData="selectedMapPageData"
      :selectedFeatures.sync="selectedFeatures"
      :questionCode="selectedQuestionCode"
      :gistaAttribute="selectedGistaAttribute"
      @update:mapPageData="selectedMapPageData = $event"
      @update:selectedFeatures="selectedFeatures = $event"
      @update:questionCode="selectedQuestionCode = $event; updateUrl();"
      @update:questionTitle="selectedQuestionTitle = $event"
    />
  </div>
</template>

<script>
import LeafletMap from '../components/LeafletMap.vue'
import Nav from '../components/Nav.vue'
import axios from 'axios';

export default {
  name: 'Home',
  components: {
    LeafletMap,
    Nav
  },
  props: {
    appArea: {
      type: String,
      default: null
    },
    mapPage: {
      type: String,
      default: null
    },
    question: {
      type: String,
      default: null
    },
    gista: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      appAreas: [],
      mapPages: [],
      selectedAppArea: null,
      selectedMapPage: null,
      selectedMapPageData: {},
      selectedFeatures: [],
      selectedQuestionCode: null,
      selectedQuestionTitle: null,
      gistaThemes: [],
      selectedGistaAttribute: null
    }
  },
  mounted () {
    axios
      .get(this.apiUrl + '/map/appAreas')
      .then(response => (this.appAreas = response.data));

    axios
      .get(this.apiUrl + '/gista/themes')
      .then(response => (this.gistaThemes = response.data));

    // Initialize from URL parameters
    if (this.appArea) {
      this.selectedAppArea = this.appArea;
    }
    if (this.mapPage) {
      this.selectedMapPage = this.mapPage;
    }
    if (this.question) {
      this.selectedQuestionCode = this.question;
      this.loadQuestionMap(this.question);
    }
    if (this.gista) {
      this.selectedGistaAttribute = this.gista;
    }
  },
  methods: {
    updateUrl() {
      const query = {};
      // MNA selection: map page xor question
      if (this.selectedQuestionCode) {
        query.question = this.selectedQuestionCode;
      } else {
        if (this.selectedAppArea) query.appArea = this.selectedAppArea;
        if (this.selectedMapPage)  query.mapPage  = this.selectedMapPage;
      }
      // GISta thematic underlay coexists with the MNA selection
      if (this.selectedGistaAttribute) {
        query.gista = this.selectedGistaAttribute;
      }
      this.$router.replace({ query });
    },
    async loadQuestionMap(questionCode) {
      // This will be called by LeafletMap component after creating question map data
      // For now, just update URL
      this.selectedQuestionCode = questionCode;
      this.updateUrl();
    },
    onQuestionPicked(questionCode) {
      // User selected a question in the Nav modal. Questions and map-page
      // selections are mutually exclusive, so clear the latter; LeafletMap's
      // watcher on questionCode will fetch and render the question map.
      this.selectedAppArea = null;
      this.selectedMapPage = null;
      this.selectedQuestionCode = questionCode;
      this.updateUrl();
    }
  },
  watch: {
    appArea: function (newAppArea) {
      if (newAppArea && newAppArea !== this.selectedAppArea) {
        this.selectedAppArea = newAppArea;
      }
    },
    mapPage: function (newMapPage) {
      if (newMapPage && newMapPage !== this.selectedMapPage) {
        this.selectedMapPage = newMapPage;
      }
    },
    question: function (newQuestion) {
      if (newQuestion && newQuestion !== this.selectedQuestionCode) {
        this.selectedQuestionCode = newQuestion;
        this.loadQuestionMap(newQuestion);
      }
    },
    selectedAppArea: function (appArea) {
      this.selectedQuestionCode = null;  // Clear question when navigating to regular maps
      this.updateUrl();
      if (appArea) {
        axios
          .get(this.apiUrl + '/map/pages/byAppArea/' + appArea)
          .then(response => {
            this.mapPages = response.data;
          })
      }
    },
    selectedMapPage: function (mapPageId) {
      this.selectedQuestionCode = null;  // Map pages and questions are still exclusive
      this.updateUrl();
      if (mapPageId) {
        axios
          .get(this.apiUrl + '/map/pages/' + mapPageId)
          .then(response => {
            this.selectedMapPageData = response.data;
          })
      }
    },
    selectedGistaAttribute: function () {
      // GISta thematic is an optional underlay — coexists with map page / question
      this.updateUrl();
    }
  }
}
</script>

<style>
#root {
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#root > #map-root {
  flex: 1 1 auto;
  min-height: 0;
}
</style>
